<template>
  <div
    id="root"
    :class="{[theme]: theme, 'focus-visible': showFocus}"
  >
    <component
      :is="appComponent"
      v-if="ready"
    />
    <connection-error :show="connectionError" />
  </div>
</template>

<script>
import smoothscroll from 'smoothscroll-polyfill';
import MasteryApp from '@/components/mastery-app';
import WuxApp from '@/components/wux-app';
import ConnectionError from '@components/singletons/connection-error';

export default {
  components: { MasteryApp, WuxApp, ConnectionError },
  computed: {
    appComponent() {
      if (this.masteryApp) {
        return 'MasteryApp';
      }
      return 'WuxApp';
    },
    showFocus() {
      return this.$store.getters['appState/showFocus'];
    },
    masteryApp() {
      return this.$store.getters['app/isMasteryApp'];
    },
    ready() {
      return this.$store.getters['app/appLoaded'] && (this.user || (this.$route.meta.public));
    },
    theme() {
      if (this.masteryApp) {
        return 'mastery';
      } else {
        return 'standard';
      }
    },
    user() {
      return this.$store.getters['session/currentUser'];
    },
    connectionError() {
      const connectionError = this.$store.getters['ui/connectionError'];
      return connectionError;
    },
  },
  mounted() {
    smoothscroll.polyfill();
    this.addTabListener();
    this.addMouseListener();
  },
  beforeDestroy() {
    this.removeMouseListener();
    this.removeTabListener();
  },
  methods: {
    addTabListener() {
      window.addEventListener('keydown', this.addFocusVisibility);
    },
    addMouseListener() {
      window.addEventListener('mousedown', this.removeFocusVisibility);
    },
    removeTabListener() {
      window.removeEventListener('keydown', this.addFocusVisibility);
    },
    removeMouseListener() {
      window.removeEventListener('mousedown', this.removeFocusVisibility);
    },
    addFocusVisibility(event) {
      // keycode 9 === tab
      if (event.keyCode === 9) {
        this.$store.dispatch('appState/setShowFocus', true);
        this.addMouseListener();
        this.removeTabListener();
      }
    },
    removeFocusVisibility(event) {
      this.$store.dispatch('appState/setShowFocus', false);
      this.addTabListener();
      this.removeMouseListener();
    },
  },
};
</script>

<style lang='scss'>
  @import '../style/base.scss';

  #root:not(.focus-visible) {
    a,
    button,
    input,
    textarea {
      outline: none;
    }
  }
</style>
